module.exports = __webpack_public_path__ + "img/security-logo.8a69e047.png";